module.exports = __webpack_public_path__ + "img/profile-user.3ea41613.svg";